import request from '../utils/request';


export const OrderAPI = {

    /**
    * 查询订单列表
    */
    queryOrderList() {
        return request({
            url: "/api/orders",
            method: "get"
        })
    },

    /**
    * 生成订单
    */
    generalOrder(planSkuCode, userPackageId) {
        return request({
            url: "/api/orders",
            method: "post",
            data: {
                "plan_sku_code": planSkuCode,
                "user_package_id": userPackageId
            }
        })
    },

    /**
    * 查询单个订单信息
    */
    queryOrderInfo(orderNo) {
        return request({
            url: `/api/orders/${orderNo}`,
            method: "get"
        })
    },


    /**
    * 取消订单
    */
    cancelOrder(orderNo) {
        return request({
            url: `/api/orders/${orderNo}/cancel`,
            method: "put"
        })
    },

    /**
    * 准备支付订单
    */
     prepayOrder(orderNo) {
        return request({
            url: `/api/orders/${orderNo}/prepay`,
            method: "get"
        })
    },





}


// WEBPACK FOOTER //
// ./src/api/order.js